var React = require('react');

function CornerDownRight (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"15 10 20 15 15 20","key":0}),React.createElement("path",{"d":"M4 4v7a4 4 0 0 0 4 4h12","key":1})]);
}

CornerDownRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-corner-down-right"};

module.exports = CornerDownRight;

CornerDownRight.default = CornerDownRight;
